import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import {
  MAX_PAGE_HEIGHT,
  MAX_PAGE_WIDTH,
  WEB_CONTENT_WIDTH,
} from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  editTrainingDialog: {
    width: WEB_CONTENT_WIDTH,
    maxWidth: MAX_PAGE_WIDTH,

    [theme.breakpoints.down('md')]: {
      width: MAX_PAGE_WIDTH,
      margin: 0,
      height: MAX_PAGE_HEIGHT,
    },
  },
  editTrainingForm: {
    paddingTop: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1),
    },
  },
  buttonWrapper: {
    padding: '16px 0',
  },
}));
